<div class="add-vendor-container">
  <p-dialog [(visible)]="isDialogOpen" [closable]="false" [draggable]="false">
    <ng-template #header>
      <div class="ui-g-11">
        <span>Add New Vendor Information</span>
      </div>
      <div
        class="ui-g-1 closesidebar diaclnav"
        (click)="closeDialog()"
        (keydown.enter)="closeDialog()"
        tabindex="0">
        <i class="mdl2-cancel close-icon"></i>
      </div>
    </ng-template>
    <div class="ui-g dialog-body">
      <div class="ui-g-12">
        <form [formGroup]="addVendorForm">
          <div class="mb-3 ui-g">
            <div class="title ui-g-4">Vendor ID *</div>
            <div class="ui-g-8">
              <input
                formControlName="vendorIdField"
                class="vendor-id-textbox p-1 w-100"
                placeholder="Enter Vendor ID"
                rows="5"
                name="vendorId"
                aria-label="vendorId"
                autocomplete="off"
                [ngClass]="{
                  'error-box':
                    addVendorFormControls['vendorIdField'].errors &&
                    addVendorFormControls['vendorIdField'].touched
                }" />
            </div>
          </div>
          <div class="mb-3 ui-g">
            <div class="title ui-g-4">Payee Name *</div>
            <div class="ui-g-8">
              <input
                formControlName="payeeNameField"
                class="payee-name-textbox p-1 w-100"
                placeholder="Enter Payee Name"
                rows="5"
                name="payeeName"
                aria-label="payeeName"
                autocomplete="off"
                [ngClass]="{
                  'error-box':
                    addVendorFormControls['payeeNameField'].errors &&
                    addVendorFormControls['payeeNameField'].touched
                }" />
            </div>
          </div>
          <div class="mb-3 ui-g">
            <div class="title ui-g-4">Payee Email *</div>
            <div class="ui-g-8">
              <input
                formControlName="payeeEmailField"
                class="payee-email-textbox p-1 w-100"
                placeholder="Enter Payee Email"
                rows="5"
                name="payeeEmail"
                aria-label="payeeEmail"
                autocomplete="new-payeeEmail"
                [ngClass]="{
                  'error-box':
                    addVendorFormControls['payeeEmailField'].errors &&
                    addVendorFormControls['payeeEmailField'].touched
                }" />
            </div>
          </div>
          <div class="mb-3 ui-g">
            <div class="title ui-g-4">Payee Email Domain (Optional)</div>
            <div class="ui-g-8">
              <input
                formControlName="payeeEmailDomainField"
                class="payee-email-domain-textbox p-1 w-100"
                autocomplete="new-payeeEmailDomainName"
                placeholder="Enter Payee Email Domain"
                rows="5"
                name="payeeEmailDomainName"
                aria-label="payeeEmailDomainName"
                autocomplete="off" />
            </div>
          </div>
          <div>
            @if (!isLoading) {
              <div class="float-right">
                <button
                  type="button"
                  pTooltip="Ok"
                  tooltipPosition="top"
                  class="ui-button-info btnpad btnmr button-ok"
                  pButton
                  (click)="onSubmitVendorInformation()"
                  [disabled]="addVendorForm.invalid">
                  Ok
                </button>
                <button
                  type="button"
                  pTooltip="Cancel"
                  (click)="closeDialog()"
                  tooltipPosition="top"
                  class="ui-button-info btnpad btnmr button-cancel"
                  pButton>
                  Cancel
                </button>
              </div>
            }
            @if (isLoading) {
              <div class="float-right">
                <p-progressSpinner
                  [style]="{
                    width: '45px',
                    height: '45px'
                  }"></p-progressSpinner>
              </div>
            }
          </div>
        </form>
      </div>
      <div class="ui-g-12">
        @for (message of inlineMessage; track message) {
          @if (message.severity === 'error') {
            <p-message
              [style]="{ width: '450px' }"
              [text]="message.detail"
              severity="error"></p-message>
          } @else {
            <p-message
              [style]="{ width: '450px' }"
              [text]="message.detail"
              severity="info"></p-message>
          }
        }
      </div>
    </div>
  </p-dialog>
</div>
